import { equals } from 'ramda'

// -----------------------------------------------------------------------------
// Exports
// -----------------------------------------------------------------------------

export const DEPLOY_ENV = process.env.ACTIVE_ENV || `development`

export const doesBuildEqual = equals(DEPLOY_ENV)

export const isProductionBuild = () => doesBuildEqual(`production`)
export const isStagingBuild = () => doesBuildEqual(`staging`)
export const isTestBuild = () => doesBuildEqual(`test`)
export const isDevelopmentBuild = () => doesBuildEqual(`development`)
